export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'korean', name: '韩漫', icon: 'ri-flag-line' },
  { slug: 'japanese', name: '日漫', icon: 'ri-global-line' },
  { slug: 'chinese', name: '国漫', icon: 'ri-map-pin-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血', icon: 'ri-fire-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'horror', name: '悬疑', icon: 'ri-ghost-line' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line' },
];

export const comics = [
  {
    id: 1,
    title: '绝世女神的复仇',
    author: '金泰熙',
    category: 'korean',
    subCategory: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20romance%20manhwa%20cover%20style%2C%20beautiful%20female%20protagonist%20with%20long%20dark%20hair%2C%20soft%20pastel%20colors%2C%20dramatic%20lighting%2C%20luxurious%20dress%2C%20palace%20background%2C%20Korean%20webtoon%20art%20style%2C%20clean%20minimal%20composition%2C%20warm%20elegant%20atmosphere&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 9.6,
    status: 'serializing',
    chapters: 87,
    views: 2850000,
    favorites: 126000,
    description: '被最信任的人背叛后，她意外重生回到三年前。这一次，她不会再被任何人利用，要让所有伤害过她的人付出代价。一场华丽复仇的序幕就此拉开……',
    tags: ['复仇', '重生', '逆袭', '甜宠'],
    updatedAt: '2026-08-03',
    featured: true,
    trending: 1,
  },
  {
    id: 2,
    title: '剑与魔法的传说',
    author: '佐藤健一',
    category: 'japanese',
    subCategory: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20fantasy%20manga%20cover%20style%2C%20young%20warrior%20holding%20magical%20sword%2C%20epic%20adventure%20theme%2C%20dragon%20silhouette%20in%20background%2C%20dramatic%20dynamic%20composition%2C%20warm%20golden%20light%2C%20shonen%20manga%20art%20style%2C%20clean%20heroic%20vibe&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 9.3,
    status: 'serializing',
    chapters: 156,
    views: 4230000,
    favorites: 198000,
    description: '平凡少年意外获得传说中的圣剑，踏上拯救世界的冒险之旅。途中结识了来自不同种族的伙伴，共同对抗黑暗势力的威胁。',
    tags: ['冒险', '奇幻', '热血', '成长'],
    updatedAt: '2026-08-04',
    featured: true,
    trending: 2,
  },
  {
    id: 3,
    title: '都市灵异事件簿',
    author: '林小凡',
    category: 'chinese',
    subCategory: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20mystery%20manhua%20cover%2C%20urban%20night%20scene%20with%20mysterious%20female%20character%2C%20dark%20atmospheric%20lighting%2C%20supernatural%20elements%2C%20modern%20city%20background%2C%20Chinese%20comic%20art%20style%2C%20moody%20and%20suspenseful&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 8.9,
    status: 'serializing',
    chapters: 64,
    views: 1680000,
    favorites: 73000,
    description: '一名普通大学生意外获得了看见灵体的能力，从此被卷入各种离奇的都市传说中。每个案件背后都隐藏着令人心碎的故事。',
    tags: ['悬疑', '灵异', '都市', '推理'],
    updatedAt: '2026-08-02',
    featured: false,
    trending: 3,
  },
  {
    id: 4,
    title: '总裁的秘密恋人',
    author: '朴智恩',
    category: 'korean',
    subCategory: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%2C%20handsome%20CEO%20male%20lead%20in%20elegant%20suit%2C%20romantic%20office%20setting%2C%20soft%20warm%20lighting%2C%20rose%20petals%2C%20beautiful%20female%20lead%2C%20Korean%20webtoon%20romance%20style%2C%20clean%20elegant%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 9.1,
    status: 'completed',
    chapters: 120,
    views: 5210000,
    favorites: 256000,
    description: '她只是去面试一份普通的工作，却意外成为了高冷总裁的私人秘书。朝夕相处中，两颗心逐渐靠近，但身份差距和家族恩怨让这段感情充满波折。',
    tags: ['恋爱', '职场', '总裁', '甜宠'],
    updatedAt: '2026-07-15',
    featured: true,
    trending: 4,
  },
  {
    id: 5,
    title: '热血篮球少年',
    author: '田中裕也',
    category: 'japanese',
    subCategory: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20sports%20manga%20cover%2C%20basketball%20player%20jumping%20for%20dunk%2C%20dynamic%20action%20pose%2C%20gymnasium%20background%2C%20energetic%20warm%20lighting%2C%20shonen%20sports%20manga%20style%2C%20clean%20athletic%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 9.4,
    status: 'serializing',
    chapters: 210,
    views: 3450000,
    favorites: 167000,
    description: '身高只有168cm的少年凭借惊人的弹跳力和不懈的努力，在高中篮球界掀起一场风暴。他要证明：篮球不是高个子的专属运动。',
    tags: ['运动', '热血', '校园', '青春'],
    updatedAt: '2026-08-04',
    featured: false,
    trending: 5,
  },
  {
    id: 6,
    title: '仙王的日常生活',
    author: '陈晓宇',
    category: 'chinese',
    subCategory: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20cultivation%20manhua%20cover%2C%20young%20immortal%20in%20traditional%20robe%2C%20holding%20smartphone%2C%20humorous%20expression%2C%20ancient%20Chinese%20palace%20mixed%20with%20modern%20elements%2C%20bright%20warm%20colors%2C%20Chinese%20comic%20art%20style&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 9.2,
    status: 'serializing',
    chapters: 345,
    views: 8500000,
    favorites: 412000,
    description: '无敌是多么寂寞！修仙界第一高手厌倦了打打杀杀，决定到现代都市体验普通人的生活。然而，平静的日子总会被各种意外打破。',
    tags: ['搞笑', '修仙', '日常', '轻松'],
    updatedAt: '2026-08-03',
    featured: true,
    trending: 6,
  },
  {
    id: 7,
    title: '暗夜吸血鬼猎人',
    author: '黑泽明美',
    category: 'japanese',
    subCategory: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20vampire%20hunter%20with%20silver%20hair%2C%20gothic%20style%20clothing%2C%20moonlit%20castle%20background%2C%20dramatic%20dark%20warm%20lighting%2C%20gothic%20manga%20art%20style%2C%20mysterious%20elegant%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 9.0,
    status: 'serializing',
    chapters: 78,
    views: 2120000,
    favorites: 95000,
    description: '在人类与吸血鬼共存的现代世界，半人半吸血鬼的少女成为最强的吸血鬼猎人。她既要对抗邪恶的纯血派吸血鬼，又要隐藏自己的真实身份。',
    tags: ['奇幻', '吸血鬼', '战斗', '暗黑'],
    updatedAt: '2026-08-01',
    featured: false,
    trending: 7,
  },
  {
    id: 8,
    title: '国民校花爱上我',
    author: '李恩珠',
    category: 'korean',
    subCategory: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20school%20romance%20manhwa%20cover%2C%20cute%20female%20student%20with%20school%20uniform%2C%20cherry%20blossom%20spring%20campus%20background%2C%20soft%20pink%20warm%20lighting%2C%20Korean%20webtoon%20romantic%20comedy%20style%2C%20clean%20youthful%20atmosphere&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 8.8,
    status: 'completed',
    chapters: 95,
    views: 3800000,
    favorites: 185000,
    description: '全校最受欢迎的校花，为什么会主动接近我这个最不起眼的宅男？原以为是恶作剧，却发现她居然是真心的……一段甜蜜又搞笑的校园恋爱就此展开。',
    tags: ['校园', '恋爱', '搞笑', '甜宠'],
    updatedAt: '2026-06-20',
    featured: false,
    trending: 8,
  },
  {
    id: 9,
    title: '末日生存法则',
    author: '王建国',
    category: 'chinese',
    subCategory: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20post-apocalyptic%20action%20manhua%20cover%2C%20survivor%20with%20tactical%20gear%20in%20ruined%20city%2C%20dramatic%20sunset%20lighting%2C%20desolate%20urban%20landscape%2C%20survival%20theme%2C%20Chinese%20comic%20art%20style%2C%20intense%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 9.5,
    status: 'serializing',
    chapters: 132,
    views: 6100000,
    favorites: 289000,
    description: '丧尸病毒爆发后，普通人李明凭借过人的智慧和勇气，在末日废土中带领幸存者们建立新的家园。资源、人性、生存，每一步都是考验。',
    tags: ['末日', '生存', '热血', '人性'],
    updatedAt: '2026-08-04',
    featured: true,
    trending: 9,
  },
  {
    id: 10,
    title: '天才料理少女',
    author: '山田花子',
    category: 'japanese',
    subCategory: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20cooking%20comedy%20manga%20cover%2C%20cute%20girl%20chef%20holding%20delicious%20dish%2C%20kitchen%20background%2C%20warm%20appetizing%20lighting%2C%20food%20manga%20style%2C%20bright%20colorful%20composition%2C%20clean%20cheerful%20vibe&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 8.7,
    status: 'serializing',
    chapters: 56,
    views: 1450000,
    favorites: 62000,
    description: '拥有绝对味觉的天才少女，用料理征服了所有人的胃和心。每一道菜背后都有一个温暖人心的故事，美食与治愈的完美结合。',
    tags: ['美食', '搞笑', '治愈', '日常'],
    updatedAt: '2026-08-02',
    featured: false,
    trending: 10,
  },
  {
    id: 11,
    title: '魔女的条件',
    author: '崔秀英',
    category: 'korean',
    subCategory: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20romance%20manhwa%20cover%2C%20beautiful%20witch%20in%20elegant%20dark%20dress%2C%20magical%20sparks%20surrounding%2C%20mysterious%20forest%20background%2C%20Korean%20webtoon%20fantasy%20style%2C%20warm%20magical%20atmosphere%2C%20clean%20elegant%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    rating: 9.3,
    status: 'serializing',
    chapters: 103,
    views: 2950000,
    favorites: 142000,
    description: '为解除诅咒，魔女必须找到一个真心爱她的人。当她遇到那个看似冷漠实则温柔的男人时，命运的齿轮开始转动。',
    tags: ['奇幻', '恋爱', '魔法', '诅咒'],
    updatedAt: '2026-08-03',
    featured: true,
    trending: 11,
  },
  {
    id: 12,
    title: '武道巅峰',
    author: '张凌云',
    category: 'chinese',
    subCategory: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20action%20manhua%20cover%2C%20young%20martial%20artist%20in%20dynamic%20fighting%20pose%2C%20ancient%20Chinese%20mountain%20temple%20background%2C%20dramatic%20warm%20lighting%2C%20Chinese%20wuxia%20comic%20style%2C%20powerful%20clean%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    rating: 9.1,
    status: 'serializing',
    chapters: 178,
    views: 3560000,
    favorites: 178000,
    description: '出身卑微的少年踏上追求武道极致的旅程。历经磨难，突破重重境界，最终站在了大陆之巅。热血、成长、友情，尽在其中。',
    tags: ['武侠', '热血', '修炼', '冒险'],
    updatedAt: '2026-08-04',
    featured: false,
    trending: 12,
  },
];

export const rankings = {
  popularity: [4, 6, 9, 2, 1, 12, 8, 5, 11, 7],
  weekly: [9, 6, 2, 12, 5, 1, 3, 11, 10, 4],
  monthly: [6, 4, 9, 2, 1, 8, 12, 5, 7, 11],
};

export const aboutInfo = {
  brandName: '女神漫画',
  foundedYear: '2022',
  description: '女神漫画成立于2022年，是国内领先的免费全集漫画在线阅读平台。我们致力于为漫画爱好者提供最优质的阅读体验，支持下拉式、弹窗、翻页等多种阅读模式，满足不同读者的阅读习惯。',
  mission: '让每一个漫画爱好者都能随时随地享受阅读的乐趣，发现更多优秀的漫画作品。',
  vision: '成为中国最受欢迎的漫画阅读平台，连接创作者与读者，推动中国漫画产业的发展。',
  values: [
    { title: '用户至上', description: '始终以用户需求为核心，不断优化阅读体验' },
    { title: '内容为王', description: '精选海内外优质漫画，确保内容质量和多样性' },
    { title: '创新驱动', description: '持续探索新的阅读模式和技术，引领行业创新' },
    { title: '合作共赢', description: '与创作者、出版社紧密合作，共建健康生态' },
  ],
  milestones: [
    { year: '2022', event: '女神漫画正式上线，首发500部精选漫画' },
    { year: '2023', event: '用户突破100万，推出下拉式阅读模式' },
    { year: '2024', event: '漫画库扩展至5000+部，上线弹窗阅读功能' },
    { year: '2025', event: '用户突破500万，推出翻页阅读模式' },
    { year: '2026', event: '全平台覆盖，成为国内TOP3漫画阅读平台' },
  ],
  testimonials: [
    { name: '小明', role: '资深漫迷', content: '女神漫画是我用过最好用的漫画App！下拉式阅读太方便了，画质也很清晰。', rating: 5 },
    { name: '小芳', role: '韩漫爱好者', content: '韩漫资源非常全，更新也很快，每天都要刷好几次看有没有更新。', rating: 5 },
    { name: '阿杰', role: '日漫粉丝', content: '翻页模式很有看纸质漫画的感觉，平台体验做得非常用心。', rating: 4 },
    { name: '小美', role: '国漫支持者', content: '国漫分类做得很好，推荐算法也很准，总是能找到我喜欢的新作品。', rating: 5 },
    { name: '大刘', role: '漫画新手', content: '界面简洁好用，分类清晰，对于刚入坑的新手非常友好。', rating: 5 },
  ],
  contact: {
    email: 'contact@nvshenmanhua.com',
    weibo: '@女神漫画官方',
    wechat: 'nvshenmanhua',
    address: '北京市朝阳区望京SOHO T3-A座 2501室',
    phone: '400-888-6666',
  },
};